<div class="content" fxFlex>
    <router-outlet></router-outlet>
  </div>
  
  <sdc-app-footer></sdc-app-footer>
  